import React from "react";
import { useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import Footer from "../components/Footer";
import { CONTACT_EMAIL, INSTAGRAM_URL } from "../config";
import { getT } from "../i18n/translations";
import { Instagram } from "lucide-react";

export default function Contact({ lang }) {
  const navigate = useNavigate();
  const c = getT(lang).contact;

  return (
    <div className="portal" data-testid="contact-page">
      <BrandHeader />

      <div className="card fade-up" data-testid="contact-card">
        <h1 style={{ fontSize: 26, fontWeight: 800, margin: "0 0 12px" }} data-testid="contact-heading">
          {c.heading}
        </h1>
        <p style={{ color: "var(--ink-soft)", margin: "0 0 22px" }} data-testid="contact-invite">
          {c.invite}
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <a
            className="btn btn-primary"
            data-testid="contact-mail"
            href="https://wa.me/381641152265"
            target="_blank"
            rel="noopener noreferrer"
          >
            {c.write}
          </a>
          <a
            className="btn"
            data-testid="contact-instagram"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ gap: 10 }}
          >
            <Instagram size={18} /> {c.instagram}
          </a>
          <button className="btn" data-testid="contact-back" onClick={() => navigate(`/${lang}`)}>
            {c.back}
          </button>
        </div>
      </div>

      <Footer testid="contact-footer" />
    </div>
  );
}
